import { AuditResultDetail } from "../Audits/AuditResults/audit-result-detail";
import { BasicResult } from "../basic-result";
import { EventOverview } from "./event-overview";

export class GetEventResult extends BasicResult{

    public EventOverview:EventOverview;
    public AuditResult:AuditResultDetail;
    constructor(values: Object = {}){
        super();
        Object.assign(this, values);    
        if (values.hasOwnProperty("EventOverview")){
            this.EventOverview = new EventOverview((values as GetEventResult)["EventOverview"]);
        }  
        if (values.hasOwnProperty("AuditResult")){
            this.AuditResult = new AuditResultDetail((values as GetEventResult)["AuditResult"]);
        }
    }
}